import React, {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import loadingImage from '../assets/loading.gif'
import {useParams} from 'react-router-dom'
import {getCharacter} from '../store/action/characterActions.js'
import harryPotterLogo from  '../assets/Harry-Potter-Logo.png'

const HarryPotter = () => {
    const {id} = useParams()
    const dispatch = useDispatch()
    let hogwarts = false
    let durmstrang = false
    let beauxbatons = false
    let harryPotter = false
    let characterHarryPotter = false
    const iconTrue = 'https://images.vexels.com/media/users/3/157931/isolated/preview/604a0cadf94914c7ee6c6e552e9b4487-curved-check-mark-circle-icon-by-vexels.png'
    const iconFalse = 'https://4vector.com/i/free-vector-cross-wrong-x-icon-clip-art_117907_Cross_Wrong_X_Icon_clip_art_hight.png'
    const character = useSelector((state) => state.characterReducer.selectedCharacter);

    useEffect(() => {
        dispatch(getCharacter(id))
    }, [dispatch, id])

    if(!character) {
        return <img id="displayedImage" src={loadingImage} alt=""/>
    }

    switch (character.school) {
        case 'Hogwarts School of Witchcraft and Wizardry':
            hogwarts = true
            break;
        case 'Durmstrang Institute':
            durmstrang = true
            break;
        case 'Beauxbatons Academy of Magic':
            beauxbatons = true
            break;
        default:
            harryPotter = true
            break;
    }

    if(character.name === 'Harry Potter') {
        characterHarryPotter = true
    }

    return (
        <>
            <div>
                {
                    characterHarryPotter && <img alt="hp" style={{height:"110px"}} src="http://www.pngmart.com/files/3/Harry-Potter-Logo-PNG-Transparent-Image.png"></img>
                }
                {
                    !characterHarryPotter && <h1>{character.name}</h1>
                }
            </div>
            <div>
                {
                    hogwarts && <img  id="logoSchool" alt="Hogwarts" src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/88ea2f25-febc-4acd-a81e-550202715dc3/d5najhh-4f69bfa2-3c87-4e75-9fc5-9bab1e3e30e9.png?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOiIsImlzcyI6InVybjphcHA6Iiwib2JqIjpbW3sicGF0aCI6IlwvZlwvODhlYTJmMjUtZmViYy00YWNkLWE4MWUtNTUwMjAyNzE1ZGMzXC9kNW5hamhoLTRmNjliZmEyLTNjODctNGU3NS05ZmM1LTliYWIxZTNlMzBlOS5wbmcifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6ZmlsZS5kb3dubG9hZCJdfQ.iuuKu_jzr7AorcexGZzjaNGQrJwDevi0Cl2F7aEDX54"/>
                }
                {
                    durmstrang && <img alt="durmstrang" id="logoSchool" src="https://vignette.wikia.nocookie.net/harrypotter/images/f/f3/DurmstrangCrest.png/revision/latest?cb=20160112161151"></img>
                }
                {
                    beauxbatons && <img alt="beauxbatons" id="logoSchool" src="https://vignette.wikia.nocookie.net/harrypotter/images/e/ea/BeauxbatonsCrestClearBg.png/revision/latest?cb=20160630041801"></img>
                }
                {
                    harryPotter && <img alt="harryPotter" src={harryPotterLogo} id="logoSchool"></img>
                }
            </div>
            <div className="container" id="icon">
                <p>Blood-Status: {character.bloodStatus}</p>
                <p>Death Eather:
                {character.deathEater && <img style={{height:"25px"}} alt="" src={iconTrue}></img>}
                {!character.deathEater && <img style={{height:"20px"}} alt="" src={iconFalse}></img>}
                </p>
                <p>Dumbledore's Army:
                {character.dumbledoresArmy && <img style={{height:"25px"}} alt="" src={iconTrue}></img>}
                {!character.dumbledoresArmy && <img style={{height:"20px"}} alt="" src={iconFalse}></img>}
                </p>
                <p>House: {character.house ? character.house : 'N/A' }

                </p>
                <p>Ministry of Magic Member:
                {character.ministryOfMagic && <img style={{height:"25px"}} alt="" src={iconTrue}></img>}
                {!character.ministryOfMagic && <img style={{height:"20px"}} alt="" src={iconFalse}></img>}
                </p>
                <p>Role: {character.role ? character.role : 'N/A' }</p>
                <p>School: {character.school ? character.school : 'N/A' }</p>
                <p>Species: {character.species ? character.species : 'N/A' }</p>
            </div>

        </>
    )
}

export default HarryPotter
